module.exports = __webpack_public_path__ + "img/strenth+2.066aa0dd.webp";